/* eslint-disable */
let isNumeric = (a) => (!isNaN(parseFloat(a)) && isFinite(a))

export let getCheckDigit = (cusip8) => {

    if (cusip8.length != 8) {}

    //Side Note - this was translated from the the VB6 code so the code may appear
    //  a little disjointed.

    var lLoop; // Looping varaiable
    var currentChar; // The current character being checked
    var lCheckSum; // The checksum value
    var lASCVal; // The ascii value of the current character
    var lCharCheck; // The value of the checksum for the current character
    var lMultiplier; // The check value multiplier

    lCheckSum = 0; //Init the value

    // convert to upper case
    cusip8 = cusip8.toUpperCase();
    // --Calculate the checksum for the odd characters up to the 7th character
    for (lLoop = 1; (lLoop <= 8); lLoop++) {
        currentChar = cusip8.charAt((lLoop - 1));

        // Get the multiplier.  The checksum from odd characters are multiplied by 2
        if ((lLoop % 2) == 0) {
            lMultiplier = 2;
        } else {
            lMultiplier = 1;
        }

        // Check if the letter is numeric
        var numericCusipChar = {}; //Will contain the current cusip character if it is numeric

        //if (System.Int32.TryParse(String.fromCharCode(currentChar), numericCusipChar)) {
        if (isNumeric(currentChar)) {
            numericCusipChar = parseInt(currentChar);
            lCharCheck = (numericCusipChar * lMultiplier);

            // --add the 10 and 1 digits together
            if (lCharCheck > 9) {
                lCheckSum += (lCharCheck / 10 | 0) + (lCharCheck % 10);
            } else {
                lCheckSum += lCharCheck;
            }
        } else {
            lASCVal = currentChar.charCodeAt();
            // Check if this a letter
            if ((lASCVal < 65 /* Keys.A */
                ) || (lASCVal > 90 /* Keys.Z */
                )) {

                // This is in invalid character, exit
                return -1;
            }

            // --Get the checksum value
            // Get the offset from the letter A and add 10
            lCharCheck = (((lASCVal - 65 /* Keys.A */
                    ) + 10) * lMultiplier);

            // --add the 10 and 1 digits together
            if (lCharCheck > 9) {
                lCheckSum += (lCharCheck / 10 | 0) + (lCharCheck % 10);
            } else {
                lCheckSum += lCharCheck;
            }
        }
    }
    // --Get the right most value of the checksum
    lCheckSum = (lCheckSum % 10);

    // Subtract from 10 if it is not 0
    if (lCheckSum != 0) {
        lCheckSum = (10 - lCheckSum);
    }

    return lCheckSum;
}

export const isCusip = (cusip9) => {
    if (!cusip9) return false


    // Must be at 9 characters
    if ((cusip9.length !== 9)) {
        return false;
    }

    var checkDigit = cusip9.substring(8, 9);

    if (!isNumeric(checkDigit)) {
        return false;
    }

    // Check the checksum against the check digit (the last digit in the string)
    return (getCheckDigit(cusip9.substring(0, 8)) == checkDigit);
}


// WEBPACK FOOTER //
// ./src/twd/is-cusip.js